<ng-container *ngIf="vm$ | async as vm">
	<div *ngIf="vm.show" class="space-y-2 mb-6">
		<div class="flex items-center">
			<div class="w-52">
				<label class="text-md font-medium">New Executions:</label>
			</div>
			<div class="flex gap-4 flex-wrap">
				<span
					*ngIf="vm.addedExecutions.length === 0"
					class="italic text-gray-400 font-light py-1 border border-white/0"
					>none</span
				>
				<span
					*ngFor="let execution of vm.addedExecutions"
					class="px-2 py-1 rounded-md border bg-white"
					>{{ execution }}</span
				>
			</div>
		</div>
		<div class="flex items-center">
			<div class="w-52">
				<label class="text-md font-medium">Removed Executions:</label>
			</div>
			<div class="flex gap-4 flex-wrap items-center">
				<span
					*ngIf="vm.removedExecutions.length === 0"
					class="italic text-gray-400 font-light py-1 border border-white/0"
					>none</span
				>
				<div
					*ngFor="let execution of vm.removedExecutions"
					class="px-2 py-1 rounded-md border bg-white"
				>
					{{ execution }}
				</div>
			</div>
		</div>
	</div>
</ng-container>
